<template>
  <div class="chat-manage">
    <div class="left">
      <ChatLeft
        :messages="lastMessages.messages"
        :users="lastMessages.users"
        @sendIdChat="openChat"
        @delete-conversation="onDeleteConversation"
      />
    </div>
    <div class="right" v-if="showChat">
      <ChatRight
        :id="userInfo.id"
        :username="userInfo.username"
        :dataMessages="dataMessages"
        @sendChatData="sendChat"
        @update-message="onUpdateMessage"
        @getChatHistory="onGetChatHistory"
      />
    </div>
  </div>
</template>

<script>
import useJwt from "@/auth/jwt/useJwt";
import { BButton } from "bootstrap-vue";
import ChatLeft from "@/components/Chat/ChatLeft.vue";
import ChatRight from "@/components/Chat/ChatRight.vue";

const audio = new Audio(
  require("@/assets/music/cskh.wav")
)

export default {
  components: { BButton, ChatLeft, ChatRight },

  data() {
    return {
      tabActive: 0,
      lastMessages: [],
      showChat: false,
      userInfo: {
        id: null,
        username: null,
      },
      dataMessages: [],
      idUser: null,
      offset: 0,
      perPage: 100,
      nomore: false
    };
  },

  methods: {
    initSocket() {
      this.$socket.emit("chat", { type: "last_messages" });
      this.$socket.on("admin", this.adminSocketListener);
    },

    adminSocketListener(data) {
      if (data.type === "history") {
        const el = document.querySelector(".chat-area");
        const h = el.scrollHeight;
        this.dataMessages = [...data.data, ...this.dataMessages]

        if(data.data.length < this.perPage) {
          this.nomore = true;
        }

        if(this.offset === 0) {
          this.scrollChatToBottom();
        } else {
          this.$nextTick(() => {
            const el = document.querySelector(".chat-area");
            el.scrollTo({
              top: el.scrollHeight - h
            });
          })
        }
      }
      if (data.type === "message") {
        if (this.idUser === data.data.id) {
          this.dataMessages.push(data.data);
          this.scrollChatToBottom();
        }

        let isCreated = true;
        this.lastMessages.messages = this.lastMessages.messages.map((e) => {
          if (e.id === data.data.id) {
            isCreated = false;
            return data.data;
          }
          return e;
        });

        if (isCreated) {
          this.lastMessages.messages = [data.data].concat(
            this.lastMessages.messages || []
          );
          this.lastMessages.users[data.data.id] = data.data.username;
        }
      }
      if (data.type === "last_messages") {
        this.lastMessages = data.data;
      }
      if (data.type === "online") {
        audio.pause();
        audio.play();
      }
    },

    openChat(id, username) {
      if(this.userInfo.id === id) return;
      this.dataMessages = [];
      this.nomore = false;
      this.userInfo.id = id;
      this.userInfo.username = username;
      this.showChat = true;
      this.idUser = id;
      this.offset = 0;
      this.$socket.emit("chat", {
        type: "history",
        data: {
          id: id,
          offset_start: 0,
          offset_end: this.offset + this.perPage,
        },
      });
      this.$nextTick(() => {
        const el = document.querySelector("body");
        window.scrollTo({
          top: el.scrollHeight,
          behavior: "smooth",
        });
      })
    },
    formatTime(timestamp) {
      let h = new Date(timestamp).getHours();
      let m = new Date(timestamp).getMinutes();

      h = h < 10 ? "0" + h : h;
      m = m < 10 ? "0" + m : m;

      return h + ":" + m;
    },
    sendChat(textChat) {
      if (!textChat) return;
      const self = this;

      self.$socket.emit(
        "chat",
        {
          type: "message",
          data: {
            to: self.idUser,
            message: textChat,
          },
        },
        (data) => {
          self.dataMessages.push(data);

          self.lastMessages.messages = self.lastMessages.messages.map((e) => {
            if (e.idUser === self.idUser) return data;
            return e;
          });

          self.scrollChatToBottom();
        }
      );
    },

    onUpdateMessage(data) {
      const { type, item } = data;
      if (type == "remove") {
        const idx = this.dataMessages.findIndex((e) => e.time === item.time);
        if (idx !== -1) {
          this.dataMessages.splice(idx, 1);
          this.lastMessages.messages = this.lastMessages.messages.map((e) => {
            if (
              e.idUser === item.idUser &&
              e.time === item.time &&
              this.dataMessages.length
            )
              return this.dataMessages.slice(-1).pop();
            return e;
          });
        }
      } else if (type == "edit") {
        const idx = this.dataMessages.findIndex((e) => e.time === item.time);
        console.log(idx);
        if (idx !== -1) {
          this.dataMessages.splice(idx, 1, ...[item]);
          this.lastMessages.messages = this.lastMessages.messages.map((e) => {
            if (
              e.idUser === item.idUser &&
              e.time === item.time &&
              this.dataMessages.length
            )
              return this.dataMessages.slice(-1).pop();
            return e;
          });
        }
      }
    },

    scrollChatToBottom() {
      const el = document.querySelector(".chat-area");
      setTimeout(() => {
        el.scrollTo({
          top: el.scrollHeight,
          behavior: "smooth",
        });
      }, 200);
    },

    onGetChatHistory() {
      if(this.nomore) return;
      this.offset = this.offset + this.perPage + 1;
      this.$socket.emit("chat", {
        type: "history",
        data: {
          id: this.idUser,
          offset_start: this.offset,
          offset_end: this.offset + this.perPage,
        },
      });
    },

    onDeleteConversation(id) {
      this.lastMessages.messages = this.lastMessages.messages.filter(e => e.id !== id);
      if(this.userInfo.id === id) {
        this.showChat = false
      }
    },
  },

  watch: {},
  created() {
    this.$http.get("/user/info");
  },
  mounted() {
    this.initSocket();
    this.$store.dispatch("verticalMenu/updateUnread", { chat: 0 });
  },

  beforeDestroy() {
    this.$socket.off("admin", this.adminSocketListener);
  },
};
</script>

<style lang="scss" scoped>
.chat-manage {
  display: flex;
  .left {
    width: 30%;
  }
  .right {
    width: 70%;
    margin-left: 15px;
  }
}

@media all and (max-width: 700px) {
  .chat-manage {
    display: block;
    .left {
      width: 100%;
    }
    .right {
      width: 100%;
      margin-left: 0px;
    }
  }
}
.table {
  .item {
    display: flex;
    max-width: 400px;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0 10px;
    border-bottom: 1px solid gray;
  }
}
.chat {
  margin-top: 30px;
  .item-left,
  .item-right {
    width: 100%;
    text-align: left;
    margin-bottom: 25px;
    span {
      color: #aaa;
      font-size: 14px;
      display: block;
    }
    .text {
      background-color: #dddada;
      padding: 8px 15px;
      border-radius: 8px;
      margin-top: 8px;
      max-width: 65vw;
      word-break: break-all;
      display: inline-block;
      .time {
        color: #5c5c5c;
        font-size: 12px;
        margin-left: 10px;
        display: inline;
      }
    }
  }

  .item-right {
    text-align: right;
    .text {
      background-color: #a0deff;
    }
  }
}
.chat-input {
  position: fixed;
  bottom: 0px;
  right: 0;
  display: flex;
  width: 500px;
  background-color: #f8f8f8;
  padding: 20px 28px 20px;
  input {
    padding: 10px 15px;
    width: 100%;
  }
  button {
    margin-left: 10px;
  }
}
@media all and (max-width: 500px) {
  .chat-input {
    width: 100%;
  }
}
</style>
